import { render, staticRenderFns } from "./BlockFooterBanner.vue?vue&type=template&id=79b66512&scoped=true&"
import script from "./BlockFooterBanner.vue?vue&type=script&lang=ts&"
export * from "./BlockFooterBanner.vue?vue&type=script&lang=ts&"
import style0 from "./BlockFooterBanner.vue?vue&type=style&index=0&id=79b66512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b66512",
  null
  
)

export default component.exports